import { FullTextMode } from "../document-state";
import { QueryComponentsCollection } from "../../../search/collections/query-components";
import { BasicTabState } from "./basic-tab-state";
import {prop} from "../../../decorators/property";

export class ReportTabState extends BasicTabState {
    @prop() public Highlighting = false;
    @prop() public HighlightedTerms: Element[] = new Array<Element>();
    @prop() public QueryComponents: QueryComponentsCollection = new QueryComponentsCollection();
    @prop() public FullTextMode = FullTextMode.Text;
    @prop() public IsHeaderHidden = false;
    @prop() public ShowHeaderControls: boolean;
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/tabs/report-state.ts